export const API_CONTRACT_VERSION = '12.2.0';
export const MANIFEST_CONTRACT_VERSION = '4.0.0';
export const PROMPT_SCHEMA_VERSION = '3.0.0';
export const VALIDATOR_CONTRACT_VERSION = '3.0.0';
export const DB_CONTRACT_VERSION = '5.0.0';
export const CONTRACT_VERSIONS = Object.freeze({
    api: API_CONTRACT_VERSION,
    manifest: MANIFEST_CONTRACT_VERSION,
    prompt: PROMPT_SCHEMA_VERSION,
    validator: VALIDATOR_CONTRACT_VERSION,
    db: DB_CONTRACT_VERSION,
});
//# sourceMappingURL=contract-versions.js.map